/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../components/table/Table";
import {
  getCompanyData,
  getHmoCompanyTransactionHistory,
  setPagination,
} from "../../../../features/company/companySlice";
import { capitalize, getAmount, getIds } from "../../../../utils/helper";

const Company = () => {
  const { loading, pagination, hmoCompanyTransactionHistory } =
      useSelector(getCompanyData),
    dispatch = useDispatch();

  useEffect(() => {
    (async () =>
      await dispatch(getHmoCompanyTransactionHistory(getIds().hmo)))();
  }, [pagination.page]);

  const data = hmoCompanyTransactionHistory?.map((data) => ({
    "Payment Ref.": capitalize(data?.referenceNumber),
    "Company Name": capitalize(data?.payerDetails?.name),
    Beneficiary: capitalize(data?.purpose?.split("=>")?.[1] || "N/A"),
    "Plan Name": capitalize(data?.planDetails?.name),
    "Plan Type": capitalize(data?.planDetails?.planType),
    Amount: "₦" + getAmount(data?.planDetails?.amount),
    "Payment Date": dayjs(data?.createdAt).format("MMM DD, YYYY"),
    _data: data,
  }));

  return (
    <Box
      className="pt-8 px-8 mt-8 pb-2 bg-[var(--c-bg-color)] rounded-lg w-100%"
      sx={{ p: 0 }}
    >
      <Table
        {...{
          data,
          pagination,
          setPagination: (data) => dispatch(setPagination(data())),
          isLoading: loading,
        }}
      />
    </Box>
  );
};

export default Company;
